import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

/**
 * Resets window scroll to the top whenever a forward navigation lands on a
 * new pathname. Skips back/forward (POP) so the browser's native scroll
 * restoration can place users where they left off. Skips search-only changes
 * (filter toggles, ?tab= switches) by depending only on pathname.
 *
 * Mount once inside <BrowserRouter>.
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();
  const navType = useNavigationType();

  useEffect(() => {
    if (navType === "POP") return;
    window.scrollTo({ top: 0, left: 0, behavior: "instant" as ScrollBehavior });
  }, [pathname, navType]);

  return null;
};

export default ScrollToTop;
